import { Button, useMediaQuery, useTheme } from "@mui/material";
import { motion } from 'framer-motion';
const AddOne = ({ handleClick,color }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            background: color === 'white' ? "#fff" : '#f9f6E0',
            paddingBottom: isSmall ? 40 : 80,
            paddingTop: isSmall ? 50 : 60,
            boxSizing: 'border-box'
        },
        subContainer: {
            width: isMobile ? '90%' : '80%'
        },
        heading: {
            fontSize: isSmall ? '18px' : isMobile ? '20px' : '38px',
            fontWeight: 'bold',
            textAlign: 'center',
            boxSizing: 'border-box'
        },
        buttonContainer: {
            marginTop: 20,
            textAlign: 'center',
        },
        button: {
            borderRadius: '30px',
            color: 'black',
            backgroundColor: 'rgb(255, 210, 48)',
            padding: '15px 60px',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '16px',
            '&:hover': {
                backgroundColor: 'rgb(255, 210, 48)',
                color: '#fff'
            }
        },
        socialContainer: {
            marginTop: 40,
            display: 'flex',
            justifyContent: 'space-evenly',
        }
    }

    return (
        <div style={styles.container}>
            <div style={styles.subContainer}>
                <motion.div
                    style={styles.heading}
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                >
                    Join 100+ D2C Fashion Brand's We've Helped Scale
                </motion.div>

                <div style={styles.buttonContainer}>
                    <Button sx={styles.button} onClick={handleClick}>Let's Connect</Button>
                </div>
            </div>
        </div >
    )



}



export default AddOne;